import { useSignupStep } from 'modules/auth/hooks/useSignupStep'
import { AuthenticatedUser } from 'modules/auth/types/auth0'
import { IconArrowLeft } from 'modules/common/components/_icons/icons'
import { Button } from 'modules/common/components/_ui/Button/Button'
import { SignupFormProgressBar } from './SignupFormProgressBar'

interface Props {
  authenticatedUser?: AuthenticatedUser | null
}

export const SignupFormHeader = ({ authenticatedUser }: Props) => {
  const { goToPreviousStep, hasPreviousStep } = useSignupStep()

  return (
    <div className="flex h-6 w-full md:hidden md:h-auto">
      <div className="w-14">
        {!authenticatedUser && hasPreviousStep && (
          <Button
            variant="none"
            className="w-14"
            onClick={goToPreviousStep}
            type="button"
            icon={<IconArrowLeft />}
          />
        )}
      </div>
      <div className="flex flex-1 items-center justify-center">
        <div className="w-40">
          <SignupFormProgressBar />
        </div>
      </div>
    </div>
  )
}
